import { Card, Flex, Grid, Heading, Text } from "@chakra-ui/react";
import React, { useCallback, useEffect, useState } from "react";
import CustomButton from "../../components/CustomButton";
import { BiArrowBack } from "react-icons/bi";
import { useLocation, useNavigate } from "react-router-dom";
import { Form, Formik } from "formik";
import CustomInput from "../../components/CustomInput";
import { useSelector } from "react-redux";
import { get_vendor_list } from "../../redux/vendorSlice";
import { get_full_product_list } from "../../redux/productSlice";
import store from "../../redux/store";
import * as Yup from "yup";
import { get_dp_list } from "../../redux/dplistSlice";
import CustomSingleInput from "../../components/CustomSingleInput";
import CustomSelect from "../../components/CustomSelect";
import SelectImage from "../../components/SelectImage";
import { toast } from "react-toastify";
import { baseUrl } from "../../utils/utils";

// const AddVehicleSchema = Yup.object().shape({
//   vendor_id: Yup.string().required("Vendor is required"),
//   dp_id: Yup.string().required("Delivery Partner is required"),
//   owner_name: Yup.string().required("Owner name is required"),
//   owner_contact: Yup.string()
//     .required("Owner contact is required")
//     .matches(/^[0-9]{10}$/, "Owner contact must be 10 digits"),
//   driver_name: Yup.string().required("Driver name is required"),
//   driver_contact: Yup.string()
//     .required("Driver contact is required")
//     .matches(/^[0-9]{10}$/, "Driver contact must be 10 digits"),
//   vehicle: Yup.string().required("Vehicle number is required"),
//   chassis: Yup.string().required("Chassis number is required"),
//   make: Yup.string().required("Make is required"),
//   type: Yup.string().required("Type is required"),
//   capacity: Yup.number()
//     .required("Capacity is required")
//     .min(1, "Capacity must be at least 1"),
// });

const AddVehicleSchema = Yup.object().shape({
  //   vendor_id: Yup.string().required("Vendor is required"),

  //   dp_id: Yup.string().required("Delivery Partner is required"),

  owner_name: Yup.string()
    .required("Owner name is required")
    .matches(/^[A-Za-z ]+$/, "Owner name must contain only letters"),

  owner_contact: Yup.string()
    .required("Owner contact is required")
    .matches(
      /^[6-9]\d{9}$/,
      "Owner contact must be a valid 10-digit mobile number"
    ),

  driver_name: Yup.string()
    .required("Driver name is required")
    .matches(/^[A-Za-z ]+$/, "Driver name must contain only letters"),

  driver_contact: Yup.string()
    .required("Driver contact is required")
    .matches(
      /^[6-9]\d{9}$/,
      "Driver contact must be a valid 10-digit mobile number"
    ),

  vehicle: Yup.string()
    .required("Vehicle number is required")
    .matches(
      /^[A-Z]{2}[0-9]{2}[A-Z]{1,2}[0-9]{4}$/,
      "Enter valid vehicle number (e.g., MH12AB1234)"
    ),

  chassis: Yup.string()
    .required("Chassis number is required")
    .matches(
      /^[A-Z0-9]{8,17}$/,
      "Chassis number must be 8–17 characters long and alphanumeric"
    ),

  make: Yup.string()
    .required("Make is required")
    .matches(/^[A-Za-z0-9 -]+$/, "Make must be alphanumeric"),

  //   type: Yup.string().required("Type is required"),

  capacity: Yup.number()
    .typeError("Capacity must be a number")
    .required("Capacity is required")
    .min(1, "Capacity must be at least 1"),
  model: Yup.number()
    .typeError("Model must be a number")
    .required("Model is required")
    .min(1990, "Model year must be after 1990")
    .max(new Date().getFullYear(), `Model year cannot be in the future`),

  rc_number: Yup.string()
    .required("RC Number is required")
    .matches(/^[A-Z0-9]{6,20}$/, "Enter valid RC Number"),

  rc_doc: Yup.mixed()
    .required("RC Document is required")
    .test("fileExists", "RC Document is required", (value) => !!value),

  insurance_number: Yup.string()
    .required("Insurance number is required")
    .matches(/^[A-Z0-9-]{6,20}$/, "Enter valid insurance number"),

  insurance_doc: Yup.mixed()
    .required("Insurance Document is required")
    .test("fileExists", "Insurance Document is required", (value) => !!value),

  pollution_number: Yup.string()
    .nullable()
    .matches(/^[A-Z0-9-]{0,20}$/, "Invalid pollution number")
    .notRequired(),

  pollution_doc: Yup.mixed().notRequired(),
});

const AddVehicle = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const location = useLocation();

  const { vendor_list } = useSelector((state) => state.vendors);

  const { dp_list } = useSelector((state) => state.dplist);


  const vendorList = vendor_list?.map((val, ind) => ({
    value: val?.id,
    label: val.legalname,
  }));
  const DP_list = dp_list?.map((val, ind) => ({
    value: val?.id,
    label: val?.legalname,
  }));

  const initialValues = {
    vendor_id: "",
    dp_id: "",
    owner_name: "",
    owner_contact: "",
    driver_name: "",
    driver_contact: "",
    vehicle: "",
    chassis: "",
    make: "",
    model: "",
    // type: "",
    capacity: "",
    emergency_contact_number: "",

    rc_number: "",
    rc_doc: null,
    insurance_number: "",
    insurance_doc: null,
    pollution_number: "",
    pollution_doc: null,
  };

  const handleSubmit = useCallback(
    async (values) => {
      try {
        console.log(values);
        const documents = [
          values?.rc_doc,
          values?.insurance_doc,
          values?.pollution_doc,
        ];
        const validDocuments = documents.filter((doc) => doc != null);
        const documentsName = [
          values?.rc_number,
          values?.insurance_number,
          values?.pollution_number,
        ];
        const validDocumentsName = documentsName.filter((doc) => doc != "");

        const namesArray = [];

        if (values.rc_doc != null) namesArray.push("RC");
        if (values.insurance_doc != null) namesArray.push("Insurance");
        if (values.pollution_doc != null) namesArray.push("Pollution");

        const names = namesArray.join(",,,"); // => e.g., "RC,,,Insurance"
        setLoading(true);
        const formData = new FormData();

        formData.append("action", "create");
        // formData.append("vendorid", values.vendor_id);
        // formData.append("dpid", values.dp_id);

        formData.append("owner_name", values.owner_name);
        formData.append("owner_contact", values.owner_contact);
        formData.append("driver_name", values.driver_name);
        formData.append("driver_contact", values.driver_contact);
        formData.append("vehicle", values.vehicle);
        formData.append("chassis", values.chassis);
        formData.append("make", values.make);
        // formData.append("type", values.type);
        formData.append("capacity", values.capacity);
        formData.append("model", values.model);
        formData.append(
          "emergency_contact_number",
          values.emergency_contact_number || ""
        );
        formData.append("supply", values.supply || "1");
        formData.append("delivery", values.delivery || "1");
        validDocuments.forEach((file, index) =>
          formData.append(`document${index}`, file)
        );
        validDocumentsName.forEach((file, index) =>
          formData.append(`document_number[]`, file)
        );
        formData.append("documentscount", validDocuments.length);
        formData.append(`names`, names);

        const response = await fetch(baseUrl + "vehicle.php", {
          method: "POST",
          body: formData,
        });

        const result = await response.json();

        if (response.ok && (result.success || result.status === "success")) {
          toast.success(result?.message);
          navigate(-1);
        } else {
          toast.error(result?.message || "Something went wrong");
          throw new Error(result.message || "Error submitting vehicle data");
        }
      } catch (error) {
        console.error("Vehicle submission error:", error);
        toast.error(error.message || "Submission failed");
      } finally {
        setLoading(false);
      }
    },
    [navigate]
  );

  useEffect(() => {
    store.dispatch(get_full_product_list());
    store.dispatch(get_vendor_list({ page: 1, rows: 10000 }));
    store.dispatch(get_dp_list({ page: 1, rows: 10000 }));
  }, []);
  return (
    <>
      <Card
        display={"flex"}
        flexDirection={"row"}
        alignItems={"center"}
        justify={"space-between"}
        paddingInline={5}
        paddingBlock={2}
      >
        <Heading fontSize={"xl"}>{"Add Vehicle"}</Heading>
        <CustomButton
          icon={<BiArrowBack color="#fff" />}
          title={"Back"}
          height={"30px"}
          b_color={"#000"}
          onClick={() =>
            navigate("/vehicle-list", {
              state: {
                page: location.state?.page,
                rows: location.state?.rows,
              },
            })
          }
        />
      </Card>
      <Formik
        key={"add"}
        initialValues={initialValues}
        validationSchema={AddVehicleSchema}
        onSubmit={handleSubmit}
        validateOnChange={true}
        validateOnBlur={true}
        enableReinitialize={true}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          setFieldValue,
          isSubmitting,
          isValid,
          dirty,
          submitForm,
        }) => (
          <Form>
            <Card padding={5}>
              <Grid templateColumns={["1fr", null, "repeat(2, 1fr)"]} gap={4}>
                {/* <CustomSingleInput
                  select
                  label={"Vendor ID"}
                  value={values.vendor_id}
                  onChange={handleChange("vendor_id")}
                  options={vendorList}
                  onBlur={handleBlur("vendor_id")}
                  placeholder={"Enter Vendor ID"}
                  error={touched.vendor_id && errors.vendor_id}
                  required={true}
                />
                <CustomSingleInput
                  select
                  options={DP_list}
                  label={"Delivery Partner"}
                  value={values.dp_id}
                  onChange={handleChange("dp_id")}
                  onBlur={handleBlur("dp_id")}
                  placeholder={"Select Delivery Partner"}
                  error={touched.dp_id && errors.dp_id}
                  required={true}
                /> */}

                <CustomSingleInput
                  label={"Owner name"}
                  value={values.owner_name}
                  onChange={handleChange("owner_name")}
                  onBlur={handleBlur("owner_name")}
                  placeholder={"Enter Owner name"}
                  error={touched.owner_name && errors.owner_name}
                  required={true}
                />
                <CustomSingleInput
                  label={"Owner Contact"}
                  value={values.owner_contact}
                  //   onChange={handleChange("owner_contact")}
                  onChange={(e) => {
                    const input = e.target.value;
                    // Allow only digits and max 10 characters
                    if (/^\d{0,10}$/.test(input)) {
                      handleChange("owner_contact")(e);
                    }
                  }}
                  onBlur={handleBlur("owner_contact")}
                  placeholder={"Enter Owner Contact"}
                  error={touched.owner_contact && errors.owner_contact}
                  required={true}
                />
                <CustomSingleInput
                  label={"Driver Name"}
                  value={values.driver_name}
                  onChange={handleChange("driver_name")}
                  onBlur={handleBlur("driver_name")}
                  placeholder={"Enter Driver Name"}
                  error={touched.driver_name && errors.driver_name}
                  required={true}
                />
                <CustomSingleInput
                  label={"Driver Contact"}
                  value={values.driver_contact}
                  onChange={(e) => {
                    const input = e.target.value;
                    // Allow only digits and max 10 characters
                    if (/^\d{0,10}$/.test(input)) {
                      handleChange("driver_contact")(e);
                    }
                  }}
                  onBlur={handleBlur("driver_contact")}
                  placeholder={"Enter Driver Contact"}
                  error={touched.driver_contact && errors.driver_contact}
                  required={true}
                />
                <CustomSingleInput
                  label={"Vehicle Number"}
                  value={values.vehicle}
                  onChange={(e) => {
                    const uppercased = e.target.value.toUpperCase();
                    // Manually update Formik's value
                    setFieldValue("vehicle", uppercased);
                  }}
                  onBlur={handleBlur("vehicle")}
                  placeholder={"Enter Vehicle Number"}
                  error={touched.vehicle && errors.vehicle}
                  required={true}
                />
                <CustomSingleInput
                  label={"Chassis Number"}
                  value={values.chassis}
                  //   onChange={handleChange("chassis")}
                  onChange={(e) => {
                    const input = e.target.value.toUpperCase();
                    // Accept only alphanumeric (letters and digits), max 17 characters
                    if (/^[A-Z0-9]{0,17}$/.test(input)) {
                      //   handleChange("chassis")(e);
                      setFieldValue("chassis", input);
                    }
                  }}
                  onBlur={handleBlur("chassis")}
                  placeholder={"Enter chassis number"}
                  error={touched.chassis && errors.chassis}
                  required={true}
                />
                <CustomSingleInput
                  label={"Make"}
                  value={values.make}
                  onChange={handleChange("make")}
                  onBlur={handleBlur("make")}
                  placeholder={"Enter Make"}
                  error={touched.make && errors.make}
                  required={true}
                />
                {/* <CustomSingleInput
                  select
                  options={[
                    { label: "minor", value: "Minor" },
                    { label: "major", value: "Major" },
                  ]}
                  label={"type"}
                  value={values.type}
                  onChange={handleChange("type")}
                  onBlur={handleBlur("type")}
                  placeholder={"Select type"}
                  error={touched.type && errors.type}
                  required={true}
                /> */}
                <CustomSingleInput
                  label={"Capacity"}
                  subLabel={"kg"}
                  value={values.capacity}
                  //   onChange={handleChange("capacity")}
                  onChange={(e) => {
                    const input = e.target.value;
                    // Allow only numbers and optional decimals
                    if (/^\d*\.?\d*$/.test(input)) {
                      handleChange("capacity")(e);
                    }
                  }}
                  onBlur={handleBlur("capacity")}
                  placeholder={"Enter Capacity"}
                  error={touched.capacity && errors.capacity}
                  required={true}
                />
                <CustomSingleInput
                  label={"Model"}
                  value={values.model} // also correct the `value` key from `modal` to `model`
                  onChange={(e) => {
                    const input = e.target.value;
                    // Allow only up to 4-digit numbers (like a year)
                    if (/^\d{0,4}$/.test(input)) {
                      handleChange("model")(e);
                    }
                  }}
                  onBlur={handleBlur("model")}
                  placeholder={"Enter Model Year"}
                  error={touched.model && errors.model}
                  required={true}
                />

                <CustomSingleInput
                  label={"Emergency Contact Number (Optional)"}
                  value={values.emergency_contact_number}
                  //   onChange={handleChange("capacity")}
                  onChange={(e) => {
                    const input = e.target.value;
                    // Allow only digits and max 10 characters
                    if (/^\d{0,10}$/.test(input)) {
                      handleChange("emergency_contact_number")(e);
                    }
                  }}
                  onBlur={handleBlur("emergency_contact_number")}
                  placeholder={"Enter Contact Number"}
                  error={
                    touched.emergency_contact_number &&
                    errors.emergency_contact_number
                  }
                />
              </Grid>
              <Text marginTop={5} marginBottom={2}>
                Documents
              </Text>
              <Grid templateColumns={["1fr", null, "repeat(2, 1fr)"]} gap={4}>
                {/* RC Card Number */}
                <CustomSingleInput
                  label={"RC Card Number"}
                  value={values.rc_number}
                  onChange={handleChange("rc_number")}
                  onBlur={handleBlur("rc_number")}
                  placeholder={"Enter RC Card Number"}
                  error={touched.rc_number && errors.rc_number}
                  required={true}
                />

                <SelectImage
                  mt={0.01}
                  label={"RC Document"}
                  filename={values.rc_doc?.name}
                  error={touched.rc_doc && errors.rc_doc}
                  onChange={(file) => setFieldValue("rc_doc", file)}
                  required
                />

                {/* Insurance Number */}
                <CustomSingleInput
                  label={"Insurance Number"}
                  value={values.insurance_number}
                  onChange={handleChange("insurance_number")}
                  onBlur={handleBlur("insurance_number")}
                  placeholder={"Enter Insurance Number"}
                  error={touched.insurance_number && errors.insurance_number}
                  required={true}
                />

                <SelectImage
                  mt={0.01}
                  label={"Insurance Document"}
                  filename={values.insurance_doc?.name}
                  error={touched.insurance_doc && errors.insurance_doc}
                  onChange={(file) => setFieldValue("insurance_doc", file)}
                  required
                />

                {/* Pollution (optional) */}
                <CustomSingleInput
                  label={"Pollution Number (Optional)"}
                  value={values.pollution_number}
                  onChange={handleChange("pollution_number")}
                  onBlur={handleBlur("pollution_number")}
                  placeholder={"Enter pollution number"}
                  error={touched.pollution_number && errors.pollution_number}
                  required={false}
                />

                <SelectImage
                  mt={0.01}
                  label={"Pollution Document"}
                  filename={values.pollution_doc?.name}
                  error={touched.pollution_doc && errors.pollution_doc}
                  onChange={(file) => setFieldValue("pollution_doc", file)}
                />
              </Grid>

              <Flex justifyContent={"center"} marginBlock={5} gap={2}>
                <CustomButton
                  title={"Submit"}
                  onClick={() => {
                    setTimeout(() => submitForm(), 0);
                  }}
                  loading={loading}
                  // disabled={isAddDisabled()}
                />
              </Flex>
            </Card>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default AddVehicle;
